export enum FullScreenLoaderEnum {
  DEFAULT = 'default',
  MODAL = 'modal',
}

export type FullScreenLoaderEnumType = keyof typeof FullScreenLoaderEnum;
